module.exports = __webpack_public_path__ + "static/does_it_work_woman-bc067d67bd12d685b10af5a672f1259a.png";